import envFile from "../env";
import {
  builtinHostnameEnv,
  defaultHostnameEnv,
  resolveEnvForHostname,
  type EnvironmentVariables,
} from "./tenant-env-resolve";

export type { EnvironmentVariables } from "./tenant-env-resolve";
export {
  builtinHostnameEnv,
  defaultHostnameEnv,
  resolveEnvForHostname,
} from "./tenant-env-resolve";

const env: { [hostname: string]: EnvironmentVariables } = {
  ...builtinHostnameEnv,
  ...envFile,
};

if (import.meta.env.DEV) {
  env.default = defaultHostnameEnv;
}

export const getEnv = (): EnvironmentVariables | undefined => {
  return resolveEnvForHostname(document.location.hostname, env);
};

export const getEnvVar = (
  name: keyof EnvironmentVariables,
): EnvironmentVariables[keyof EnvironmentVariables] | null => {
  const resolved = getEnv();
  if (!resolved || !(name in resolved)) {
    return null;
  }
  return resolved[name];
};
